import React from 'react';

import { useTypedDispatch, useTypedSelector } from '@/store/store';
import {
  deleteCarGearbox,
  getSelectedFilters,
  getStockFilterParams,
  setCarGearbox,
  setCarGearboxAll,
  setPage,
} from '@/store/reducers/cars-stock';
import { getGearboxOptions } from '@/modules/CarsStock/components/common.helpers';
import StockFilterMultiSelectParts from '@/components/StockFilterMultiSelectParts';
import {
  StockFilterMultiSelectPartsOptionType,
  StockFilterMultiSelectPartsSelectedOptionType,
} from '@/components/StockFilterMultiSelectParts/types';

function GearboxFilter() {
  const dispatch = useTypedDispatch();
  const stockFilterParams = useTypedSelector(getStockFilterParams);
  const selectedGearboxes =
    useTypedSelector(getSelectedFilters).selectedParams.selectedGearbox;

  const gearboxOptions = getGearboxOptions(stockFilterParams);

  const handleChangeGearbox = (
    gearbox: StockFilterMultiSelectPartsSelectedOptionType
  ) => {
    dispatch(setCarGearbox(gearbox));
    dispatch(setPage(1));
  };

  const handleChangeGearboxAll = (
    gearbox: StockFilterMultiSelectPartsOptionType
  ) => {
    dispatch(setCarGearboxAll(gearbox));
    dispatch(setPage(1));
  };

  const handleClearGearbox = () => {
    dispatch(deleteCarGearbox());
    dispatch(setPage(1));
  };

  return (
    <StockFilterMultiSelectParts
      label="Коробка передач"
      options={gearboxOptions}
      selectedOptions={selectedGearboxes}
      onChange={handleChangeGearbox}
      onChangeAll={handleChangeGearboxAll}
      onClear={handleClearGearbox}
    />
  );
}

export default GearboxFilter;
